module.exports = __webpack_public_path__ + "static/img/粮食守护.6b82384.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/粮食守护.gif
// module id = 6nvl
// module chunks = 3